<template>
  <BasePage :back-button="true" :pageTitle="__DICT__.actionMenu.loadCoach" show-menu show-footer>
    <Card margin="">
      <template #header>
        <ul class="nav nav-tabs card-header-tabs">
          <li class="nav-item">
            <a
                class="nav-link"
                :class="{ 'active': activeTab === 'outbound' }"
                href="#"
                @click.prevent="activeTab = 'outbound'"
            >
              {{ __DICT__.outbound }}
            </a>
          </li>
          <li class="nav-item">
            <a
                class="nav-link"
                :class="{ 'active': activeTab === 'inbound' }"
                href="#"
                @click.prevent="activeTab = 'inbound'"
            >
              {{ __DICT__.inbound }}
            </a>
          </li>
        </ul>
      </template>
      <div v-if="activeTab === 'inbound'" class="list-group list-group-flush">
        <router-link
            v-for="coach in inboundCoaches"
            :key="coach"
            :to="`/loadCoach/${coach}/inbound`"
            class="list-group-item list-group-item-action"
        >
          {{ coach }}
          <div class="text-muted small">
            {{ formatFirstDeparture(getCoachTransportInfo(coach, 'inbound')) }}
          </div>
        </router-link>
        <div v-if="inboundCoaches.length === 0" class="text-center py-3 text-muted">
          {{ __DICT__.selectCoach.noInboundCoaches }}
        </div>
      </div>
      <div v-else class="list-group list-group-flush">
        <router-link
            v-for="coach in outboundCoaches"
            :key="coach"
            :to="`/loadCoach/${coach}/outbound`"
            class="list-group-item list-group-item-action"
        >
          {{ coach }}
          <div class="text-muted small">
            {{ formatFirstDeparture(getCoachTransportInfo(coach, 'outbound')) }}
          </div>
        </router-link>
        <div v-if="outboundCoaches.length === 0" class="text-center py-3 text-muted">
          {{ __DICT__.selectCoach.noOutboundCoaches }}
        </div>
      </div>
    </Card>
  </BasePage>
</template>

<script setup>
import {ref, onMounted, computed} from "vue";
import { api } from "@/services/api.js";
import BasePage from "@/components/BasePage.vue";
import { useWeekStore} from "@/stores/week.js";
import { Card } from "@/components/atomic";

const weekStore = useWeekStore()
const activeTab = ref('outbound');
const inboundCoaches = ref([]);
const outboundCoaches = ref([]);
const weekData = ref([]);


const coachPassengers = computed(() => {
  const coaches = {
    inbound: {},
    outbound: {}
  }

  const data = weekData.value || []
  data.forEach(passenger => {
    // Find both inbound and outbound coach allocations
    const allocations = passenger.allocPlaces?.filter(place =>
        place.transport?.transportType === "coach_travel"
    ) || []

    allocations.forEach(allocation => {
      const transport = allocation.transport

      if (transport?.coach) {
        // Extract direction by removing 'transport-' prefix
        const direction = transport.type?.replace('transport-', '')

        if (!coaches[direction][transport.coach]) {
          coaches[direction][transport.coach] = {
            passengers: [],
            transportInfo: transport
          }
        }
        coaches[direction][transport.coach].passengers.push(passenger)
      }
    })
  })
  return coaches
})

function getCoachTransportInfo(coachId, direction) {
  return coachPassengers.value[direction]?.[coachId]?.transportInfo
}

function formatFirstDeparture(transportInfo) {
  if (!transportInfo?.departures?.length) return ''
  const deps = transportInfo.departures.sort((a, b) =>
      new Date(a.dateTime).getTime() - new Date(b.dateTime).getTime()
  )
  const firstDeparture = deps[0]
  const date = new Date(firstDeparture.dateTime)

  return `${firstDeparture.location} - ${date.toLocaleDateString('en-GB')} ${date.toLocaleTimeString('en-GB')}`
}

onMounted(async () => {
  const coaches = await api.get(`/api/coach/allCoaches/${weekStore.weekId}`);
  inboundCoaches.value = coaches.inbound;
  outboundCoaches.value = coaches.outbound;
  weekData.value = weekStore.weekData;
});
</script>